import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import DiscordCallback from "@/components/DiscordCallback";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import CreatorDashboard from "@/pages/CreatorDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import MemberDashboard from "@/pages/MemberDashboard";
import Storefront from "@/pages/Storefront";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import DiscordBot from "@/pages/DiscordBot";
import { Loader2 } from "lucide-react";

function FullLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAF9F6]">
      <Loader2 className="w-8 h-8 text-violet-600 animate-spin" />
    </div>
  );
}

function Protected({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) return <FullLoader />;
  if (!user) return <Navigate to="/auth" replace />;
  if (role && user.role !== role) {
    return <Navigate to={user.role === "creator" ? "/creator" : "/member"} replace />;
  }
  return children;
}

function AppRouter() {
  useLocation();
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/auth" element={<Auth />} />
      <Route path="/auth/discord/callback" element={<DiscordCallback />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/s/:handle" element={<Storefront />} />
      <Route path="/discord-bot" element={<DiscordBot />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/creator" element={<Protected role="creator"><CreatorDashboard /></Protected>} />
      <Route path="/member" element={<Protected role="member"><MemberDashboard /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
